/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderItemObjectType,
    OrderItemObjectTypeFromJSON,
    OrderItemObjectTypeFromJSONTyped,
    OrderItemObjectTypeToJSON,
} from './OrderItemObjectType';
import {
    OrderItemType,
    OrderItemTypeFromJSON,
    OrderItemTypeFromJSONTyped,
    OrderItemTypeToJSON,
} from './OrderItemType';
import {
    OrderItemV2Amount,
    OrderItemV2AmountFromJSON,
    OrderItemV2AmountFromJSONTyped,
    OrderItemV2AmountToJSON,
} from './OrderItemV2Amount';
import {
    OrderItemV2UnitAmount,
    OrderItemV2UnitAmountFromJSON,
    OrderItemV2UnitAmountFromJSONTyped,
    OrderItemV2UnitAmountToJSON,
} from './OrderItemV2UnitAmount';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    id: string;
    /**
     * 
     * @type {OrderItemObjectType}
     * @memberof OrderItem
     */
    object: OrderItemObjectType;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    order_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    program_id: string;
    /**
     * 
     * @type {OrderItemV2Amount}
     * @memberof OrderItem
     */
    amount: OrderItemV2Amount;
    /**
     * 
     * @type {OrderItemV2UnitAmount}
     * @memberof OrderItem
     */
    unit_amount: OrderItemV2UnitAmount;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItem
     */
    include_fee: boolean;
    /**
     * Description of the line item, meant to be displayable to the user
     * @type {string}
     * @memberof OrderItem
     */
    description?: string;
    /**
     * The ID of the associated object for this line item.
     * @type {any}
     * @memberof OrderItem
     */
    parent?: any;
    /**
     * A positive integer representing the number of instances of parent that are included in this order item. Applicable/present only if type is registration.
     * @type {number}
     * @memberof OrderItem
     */
    quantity: number;
    /**
     * 
     * @type {OrderItemType}
     * @memberof OrderItem
     */
    type: OrderItemType;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderItem
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof OrderItem
     */
    created_by?: User;
    /**
     * 
     * @type {Date}
     * @memberof OrderItem
     */
    updated?: Date;
    /**
     * 
     * @type {User}
     * @memberof OrderItem
     */
    updated_by?: User;
}

export function OrderItemFromJSON(json: any): OrderItem {
    return OrderItemFromJSONTyped(json, false);
}

export function OrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': OrderItemObjectTypeFromJSON(json['object']),
        'order_id': json['order_id'],
        'program_id': json['program_id'],
        'amount': OrderItemV2AmountFromJSON(json['amount']),
        'unit_amount': OrderItemV2UnitAmountFromJSON(json['unit_amount']),
        'include_fee': json['include_fee'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'quantity': json['quantity'],
        'type': OrderItemTypeFromJSON(json['type']),
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': !exists(json, 'created_by') ? undefined : UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
    };
}

export function OrderItemToJSON(value?: OrderItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': OrderItemObjectTypeToJSON(value.object),
        'order_id': value.order_id,
        'program_id': value.program_id,
        'amount': OrderItemV2AmountToJSON(value.amount),
        'unit_amount': OrderItemV2UnitAmountToJSON(value.unit_amount),
        'include_fee': value.include_fee,
        'description': value.description,
        'parent': value.parent,
        'quantity': value.quantity,
        'type': OrderItemTypeToJSON(value.type),
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': UserToJSON(value.updated_by),
    };
}

